'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactSlidedown = require('react-slidedown');

var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _Petitions = require('./Petitions.css');

var _Petitions2 = _interopRequireDefault(_Petitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManagerPetition = (_dec = (0, _reactCssModules2.default)(_Petitions2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ManagerPetition, _Component);

  function ManagerPetition(props) {
    (0, _classCallCheck3.default)(this, ManagerPetition);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ManagerPetition.__proto__ || (0, _getPrototypeOf2.default)(ManagerPetition)).call(this, props));

    _this.renderLogo = function (title) {
      var fileName = _format2.default.imgPath(title);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }
      if (hasLogo) {
        return _react2.default.createElement('img', {
          styleName: 'sidebar-logo',
          src: companyLogo,
          alt: title
        });
      } else {
        console.log(fileName);
        return _react2.default.createElement(
          'span',
          null,
          title
        );
      }
    };

    var petitionConfigs = {
      vanguard: {
        companyshortname: 'Vanguard',
        companyfullname: 'Vanguard Group',
        pathname: 'Vanguard',
        title: 'Vanguard Needs a No Deforestation Policy',
        url: 'https://actionnetwork.org/petitions/vanguard-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/vanguard-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-vanguard-needs-a-no-deforestation-policy-2',
        imgpath: 'Vanguard',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Every year, the world loses an area of tropical rainforest the size of the United Kingdom.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local communities.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Vanguard holds hundreds of millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests. Vanguard\u2019s continued financing of the world\u2019s worst deforesters exposes Vanguard and its clients to reputational and financial risk \u2013 and Vanguard has no policy in place to stop the destruction.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'As one of the world\u2019s largest investment firms, Vanguard pioneered a model of investment where the firm invests in virtually every public company in the world through passive funds \u2013 meaning it gives up any control over what those companies do. Today, Vanguard is among the world\u2019s top investors in both fossil fuels and the companies responsible for the global deforestation crisis \u2013 and it has taken no responsibility for the destruction these companies cause to our forests, our climate, and the rights of communities.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Large fund companies like Vanguard can move the entire market and play a crucial role in averting catastrophe, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge Vanguard to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Vanguard needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      blackrock: {
        companyshortname: 'BlackRock',
        companyfullname: 'BlackRock/iShares',
        pathname: 'BlackRock%2FiShares',
        title: 'Tell BlackRock to Deal With its Deforestation Problem',
        url: 'https://actionnetwork.org/petitions/tell-blackrock-to-deal-with-its-deforestation-problem-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/tell-blackrock-to-deal-with-its-deforestation-problem-2?format=js&source=widget',
        widgetid: 'can-petition-area-tell-blackrock-to-deal-with-its-deforestation-problem-2',
        imgpath: 'BlackRock/iShares',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Every year, the world loses an area of tropical rainforest the size of the United Kingdom.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, cattle, pulp and paper, soy, rubber and timber is responsible for almost a quarter of all global greenhouse gas emissions and is also a leading cause of violent land conflicts around the world.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'BlackRock, the world\'s largest investment firm, is among the world\u2019s top investors in the agribusiness companies responsible for destroying our tropical rainforests. To make the urgent transformations needed to end global deforestation and reign in the climate crisis, BlackRock needs to change its ways.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'BlackRock owns shares in the world\u2019s largest cattle companies, the world\u2019s largest palm oil companies, and the world\u2019s largest pulp and paper companies. Aside from a few public statements, BlackRock has done almost nothing to stop these companies from tearing down the world\u2019s last great rainforests.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Around the world, people of all ages, from grandmothers to youth, have been rising up to tell BlackRock to divest from destruction.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'As one of the largest investors in the agribusiness industry from Brazil to Borneo, there\u2019s a lot BlackRock can do to deal with its deforestation problem. It can use shareholder power to pressure the companies it owns to end deforestation. It can vote out the managers at these companies that let the problems continue. It can make deforestation free funds a default option for all of its clients.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Join the movement to fix BlackRock\u2019s big deforestation problem: tell BlackRock to adopt a No Deforestation Policy!'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'The Wall Street titan manages a jaw-dropping $10 trillion in assets. Trillions of dollars that belong to everyday people like you and me. Trillions of dollars that could help solve the climate crisis rather than fund rainforest destruction and displacing Indigenous people.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'There is no way through the climate crisis that doesn\u2019t involve making Wall Street change its ways, beginning with the biggest investors, like BlackRock. As a self-proclaimed leader in responsible investing, BlackRock should be investing our dollars in fighting the destruction of lands and communities. Together we can pressure it to change course.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge BlackRock to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Larry Fink and Michelle Edkins,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'To repeat a question posed by Al Gore: \u201CDoes BlackRock want to continue to finance the destruction of human civilization, or not?\u201D'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Back in 2019, eight U.S. Senators urged BlackRock to disclose its due diligence in regards to the deforestation wrought by the palm oil sector. Two months later, Liberian human rights attorney Alfred Brownell blasted BlackRock during his Goldman Prize acceptance speech for financing Golden Agri-Resources, a company responsible for vast rainforest destruction and human rights abuses. At your AGM in 2020, Amazonian Indigenous leaders challenged BlackRock to get its money out of Amazon destruction. In December of that year, you heard from eighteen Members of Congress urging the same thing \u2013 stop financing companies that are burning down the Amazon. Over the last several years, people ages 8 to 80 have held protests at BlackRock offices around the world, demanding you divest from fossil fuels and defund deforestation.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Don\u2019t you think it\'s time BlackRock developed a policy to categorically address the deforestation risk in your portfolios?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Your clients and beneficiaries know it. Governments from the US and the EU to Asia know it. And youth around the world have begun to see BlackRock for what it is \u2013 one of the largest investors in the destruction of their future.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'You have joined the Climate Action 100+ and the Net Zero Asset Managers\u2019 Initiative. You\u2019ve done all the symbolic and rhetorical things \u2013 but in the face of ugly attacks from the fossil fuel-funded right wing, you\u2019ve backtracked on your commitment to tackling climate risk as investment risk. BlackRock\u2019s rhetoric has grown threadbare. Until BlackRock chooses to engage with the people truly impacted by the abuses of your investee companies, and until BlackRock adopts strong policies to defund deforestation \u2013 and fossil fuels \u2013 there is no reason to believe that BlackRock\u2019s rhetoric about sustainability and social purpose has any merit whatsoever.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and you need to do the same. It is both a moral and an economic imperative, and you know it. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge BlackRock to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      fidelity: {
        companyshortname: 'Fidelity',
        companyfullname: 'Fidelity Investments',
        pathname: 'Fidelity%20Investments',
        title: 'Fidelity Needs a No Deforestation Policy',
        url: 'https://actionnetwork.org/petitions/fidelity-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/fidelity-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-fidelity-needs-a-no-deforestation-policy-2',
        imgpath: 'Fidelity Investments',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Tropical rainforests are home to the world\u2019s greatest biodiversity, to millions of indigenous peoples, and are essential to maintaining a stable climate. Today, our rainforests are facing greater threats than ever \u2013 and the investors like Fidelity that are complicit in the destruction are dragging their feet.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land for industrial plantation agriculture is also a leading cause of violent land conflicts.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Fidelity has huge investments in companies like Bunge, Noble Group, Golden-Agri Resources and Resolute Forest Products that grow, trade or use palm oil, beef and soy in their products but have failed to eliminate deforestation and human rights abuses from their operations. This means Fidelity has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In order to do that, Fidelity needs a high-level policy to set the course.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Tell Fidelity to adopt a No Deforestation Policy!'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'As one of the world\u2019s largest fund managers, Fidelity can play a crucial role in averting catastrophic climate outcomes, and instead financing the transition to a livable planet. But Fidelity won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge Fidelity to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Fidelity needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      capitalgroup: {
        companyshortname: 'Capital Group',
        companyfullname: 'American Funds from Capital Group',
        title: 'Capital Group Needs a No Deforestation Policy',
        pathname: 'American%20Funds',
        url: 'https://actionnetwork.org/petitions/capital-group-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/capital-group-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-capital-group-needs-a-no-deforestation-policy-2',
        imgpath: 'American Funds',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Things aren\u2019t looking good for the world\u2019s forests. With surging deforestation from Brazil to the Congo Basin, environmental policy roll backs, assaults on environmental defenders, and fires burning through rainforests on four continents, we need to drastically change course or watch as the last of our rainforests go up in smoke.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Deforestation to open plantations for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. American Funds, owned by Capital Group, has huge investments in companies like Pepsico, Yum Brands, Hormel, McDonald\u2019s and Procter & Gamble that use palm oil, beef and paper pulp in their products but have failed to eliminate deforestation from their operations. This means Capital Group has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'In order to do that, Capital Group needs to get its own house in order.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'If they take appropriate action, large fund companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge Capital Group to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Capital Group needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      dimensionalfundadvisors: {
        companyshortname: 'Dimensional Fund Advisors',
        companyfullname: 'Dimensional Fund Advisors',
        title: 'Dimensional Fund Advisors Needs a No Deforestation Policy',
        pathname: 'Dimensional%20Fund%20Advisors',
        url: 'https://actionnetwork.org/petitions/dimensional-fund-advisors-needs-a-no-deforestation-policy/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/dimensional-fund-advisors-needs-a-no-deforestation-policy?format=js&source=widget',
        widgetid: 'can-petition-area-dimensional-fund-advisors-needs-a-no-deforestation-policy',
        imgpath: 'Dimensional Fund Advisors',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dimensional Fund Advisors has big investments in some of the most environmentally destructive companies in the world, including tropical logging companies, beef producers, and the world\u2019s largest palm oil growers and traders.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dimensional was the first large US investment firm to explicitly remove palm oil producers from its sustainability funds \u2013 so we know they are aware of the issues. But Dimensional still has huge exposure to companies like Hormel, Resolute Forest Products, Posco, and JBS, the major the Brazilian beef trader. In order to take responsibility, Dimensional should immediately implement a robust forest policy across all its investment products.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Given the high risk of illegal activity, money laundering, environmental violations, and human rights abuses associated with deforestation, Dimensional should employ heightened due diligence procedures and eliminate the most egregious and recalcitrant companies from all of its portfolios.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Tell Dimensional to adopt a No Deforestation Policy!'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'If they take appropriate action, large mutual funds companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge Dimensional to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Dimensional Fund Advisors needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      invesco: {
        companyshortname: 'Invesco',
        companyfullname: 'Invesco',
        title: 'Invesco Needs a No Deforestation Policy',
        pathname: 'Invesco',
        url: 'https://actionnetwork.org/petitions/invesco-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/invesco-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-invesco-needs-a-no-deforestation-policy-2',
        imgpath: 'Invesco',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Tropical rainforests are home to the world\u2019s greatest biodiversity, to millions of indigenous peoples, and are essential to maintaining a stable climate. Today, our rainforests are facing greater threats than ever \u2013 and the big fund companies like Invesco that are complicit in the destruction are dragging their feet.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Invesco has big investments in companies like Sysco, Tyson, Hormel and Noble Group that grow, trade or use palm oil, beef, rubber and soy in their products but have failed to eliminate deforestation from their operations. This means Invesco has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In order to do that, Invesco needs to a No Deforestation Policy.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Invesco is built on a model of investment where the firm invests in virtually every public company in the world through passive funds \u2013 meaning it gives up any control over what those companies do. Despite its huge investments in both fossil fuels and the companies responsible for the global deforestation crisis, Invesco has taken no responsibility for the destruction these companies cause to our forests, our climate, and the rights of communities.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Large fund companies like Invesco have the power move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge Invesco to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe Invesco needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      jpmorgan: {
        companyshortname: 'JPMorgan',
        companyfullname: 'JPMorgan',
        title: 'JPMorgan Needs a No Deforestation Policy',
        pathname: 'JPMorgan',
        url: 'https://actionnetwork.org/petitions/jpmorgan-needs-a-no-deforestation-policy/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/jpmorgan-needs-a-no-deforestation-policy?format=js&source=widget',
        widgetid: 'can-petition-area-jpmorgan-needs-a-no-deforestation-policy',
        imgpath: 'JPMorgan',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Tropical rainforests are home to the world\u2019s greatest biodiversity, to millions of indigenous peoples, and are essential to maintaining a stable climate. Today, our rainforests are facing greater threats than ever \u2013 and the big fund companies like JPMorgan that are complicit in the destruction are dragging their feet.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'JPMorgan has big investments in companies like Sysco, Tyson, Hormel and Noble Group that grow, trade or use palm oil, beef, rubber and soy in their products but have failed to eliminate deforestation from their operations. This means JPMorgan has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In order to do that, JPMorgan needs to a No Deforestation Policy.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'JPMorgan is built on a model of investment where the firm invests in virtually every public company in the world through passive funds \u2013 meaning it gives up any control over what those companies do. Despite its huge investments in both fossil fuels and the companies responsible for the global deforestation crisis, JPMorgan has taken no responsibility for the destruction these companies cause to our forests, our climate, and the rights of communities.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Large fund companies like JPMorgan have the power move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge JPMorgan to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe JPMorgan needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      mfs: {
        companyshortname: 'MFS',
        companyfullname: 'MFS',
        title: 'MFS Needs a No Deforestation Policy',
        pathname: 'MFS',
        url: 'https://actionnetwork.org/petitions/mfs-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/mfs-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-mfs-needs-a-no-deforestation-policy-2',
        imgpath: 'MFS',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Every year, the world is losing an area of tropical rainforest the size of the United Kingdom.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local communities.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'MFS has big investments in companies like Archer Daniels Midland, Pepsico and Procter & Gamble that grow, trade or use palm oil, beef, pulp and soy in their products but have failed to eliminate deforestation from their operations. This means MFS has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In order to do that, MFS needs to get its own house in order.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'If they take appropriate action, large mutual fund companies have the power to move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge MFS to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe MFS needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      statestreet: {
        companyshortname: 'State Street',
        companyfullname: 'State Street',
        title: 'State Street Needs a No Deforestation Policy',
        pathname: 'State%20Street',
        url: 'https://actionnetwork.org/petitions/state-street-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/state-street-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-state-street-needs-a-no-deforestation-policy-2',
        imgpath: 'SPDR State Street Global Advisors',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'State Street is one of the largest and most influential investment firms in the world. Unlike many large investors, State Street actually has a number of fossil free funds \u2013 which shows that State Street understands the existential threat of climate change.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Yet, even in its fossil-free funds, and across its portfolios, State Street still has huge investments in companies like JBS, Sime Darby, Posco and Mitsubishi that grow and trade palm oil, beef, and rubber, and others like Tesco and Carrefour that use these commodities in their products but have failed to eliminate deforestation from their operations. This means State Street has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'If they take appropriate action, large fund companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge State Street to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe State Street needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      troweprice: {
        companyshortname: 'T. Rowe Price',
        companyfullname: 'T. Rowe Price',
        title: 'T. Rowe Price Needs a No Deforestation Policy',
        pathname: 'T%20Rowe%20Price',
        url: 'https://actionnetwork.org/petitions/t-rowe-price-needs-a-no-deforestation-policy-2/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/t-rowe-price-needs-a-no-deforestation-policy-2?format=js&source=widget',
        widgetid: 'can-petition-area-t-rowe-price-needs-a-no-deforestation-policy-2',
        imgpath: 'T. Rowe Price',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Every year, the world loses an area of tropical rainforest the size of the United Kingdom.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of f land for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local communities.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'T. Rowe Price has huge investments in companies like Sysco, Tyson, Hormel and Sumitomo Rubber that grow, trade or use palm oil, beef, rubber and soy in their products but have failed to eliminate deforestation from their operations. This means T. Rowe Price has a key role to play in voting for No Deforestation policies at these companies and engaging with company management to make sure these policies are implemented.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In order to do that, T. Rowe Price needs to get its own house in order.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'If they take appropriate action, large mutual fund companies can move the entire market and play a crucial role in averting catastrophic climate outcomes, and instead finance the transition to a livable planet. But they won\u2019t do it without pressure from us.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Urge T. Rowe Price to adopt a No Deforestation Policy!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Fund Manager,'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe T. Rowe Price needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      },
      tiaainvestmentsnuveen: {
        companyshortname: 'TIAA Investments Nuveen',
        companyfullname: 'TIAA Investments Nuveen',
        title: 'TIAA Investments Nuveen Needs a No Deforestation Policy',
        pathname: 'TIAA%20Investments%20Nuveen',
        url: 'https://actionnetwork.org/petitions/tiaanuveen-needs-a-no-deforestation-policy/',
        widgeturl: 'https://actionnetwork.org/widgets/v4/petition/tiaanuveen-needs-a-no-deforestation-policy?format=js&source=widget',
        widgetid: 'can-petition-area-tiaanuveen-needs-a-no-deforestation-policy',
        imgpath: 'TIAA Investments Nuveen',
        intro1: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Along with its subsidiary Nuveen, TIAA is one of the largest pension funds in the U.S. Despite its reputation for social responsibility, TIAA is also one of the world\u2019s largest investors in fossil fuels and agribusiness, and the largest investor of farmland in the world, with almost 2 million acres of farmland on four continents worth as much as $10 billion.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'But TIAA\u2019s agribusiness investments and farmland deals are causing more harm than it lets on. These deals are driving land grabs, deforestation, and human rights violations, and they\u2019re squeezing out family farmers and rural communities.'
          )
        ),
        intro2: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'TIAA is buying farmland in countries and in regions where land grabbing and fraud are widespread. Its activities are both contributing to and benefiting from the dispossession of local communities, increasing hunger, and violence. TIAA\u2019s farmland deals also come at a heavy ecological cost. They are destroying the environment and contaminating water sources because they promote and spread a plantation model of agriculture that relies heavily on chemical inputs.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'TIAA also holds millions of dollars of shares in palm oil, timber and beef producers like Tyson, Hormel, International Paper and Golden-Agri Resources, but has resisted efforts to pressure these companies to address their deforestation problem.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Demand that TIAA stop buying farmland and institute a No Deforestation Policy!'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'As a firm that manages funds for academics and non-profits, TIAA should be especially rigorous in its environmental and social standards. Together we can pressure it to change course.'
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'scroll-link' },
            _react2.default.createElement(
              _reactScroll.Link,
              {
                activeClass: 'active-scroll-link',
                to: 'section1',
                spy: true,
                smooth: true,
                offset: -70,
                duration: 500
              },
              _react2.default.createElement(
                'b',
                null,
                'Tell TIAA to adopt a No Deforestation Policy and get out of farmland altogether!'
              )
            )
          )
        ),
        letter: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Dear Members of TIAA\u2019s Corporate Governance and Social Responsibility Committee:'
          ),
          _react2.default.createElement(
            'p',
            null,
            'I have serious concerns about TIAA\u2019s involvement in land grabbing, deforestation, and human rights violations through its holdings in deforestation-risk commodities and its direct acquisitions of farmland.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber and cattle is responsible for almost one quarter of all global greenhouse gas emissions, as well as an epidemic of land conflicts and widespread abuses of the rights of indigenous peoples. As an investment firm that holds millions of dollars in shares in the agribusiness companies most responsible for devastating our rainforests, these issues expose you and your clients to a host of material risks.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Environmental and human rights impacts \u2013 and climate impacts above all \u2013 are increasingly recognized to drive material risks to investment. Awareness of these risks is growing quickly within the financial sector \u2013 and now is the time for you to get on board.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Leading responsible investment firms have begun to develop comprehensive policies to address deforestation risk, and I believe TIAA needs to do the same. It is both a moral and an economic imperative. You have tremendous power \u2013 and the world needs you to start using that power responsibly. I urge you to adopt a strong deforestation risk policy across all your portfolios.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In addition, given TIAA/Nuveen\u2019s approach to farmland investment, I ask you to halt your acquisitions of farmland, especially in fragile ecosystems and areas where land title is strongly contested and to engage in an effort to return lands in the Brazilian Cerrado to local community management.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thank you.'
          )
        )
      }
    };
    var petitionConfig = null;
    if (props.manager && petitionConfigs[props.manager]) {
      petitionConfig = petitionConfigs[props.manager];
    }
    _this.state = {
      petitionConfig: petitionConfig,
      showFullPetition: false
    };
    return _this;
  }

  (0, _createClass3.default)(ManagerPetition, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.state.petitionConfig) {
        return null;
      }
      var manager = this.state.petitionConfig;
      var headlineImg = require('../../../static/images/monkeys-circle.png');
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet('Tell ' + manager.companyshortname + ' to adopt a No Deforestation policy', 'Mutual fund managers are among the world\u2019s top investors in the agribusiness companies responsible for destroying our tropical rainforests.', _config2.default.domain + _config2.default.routes.petitions + '/' + manager.companyshortname),
        _react2.default.createElement(
          'div',
          { styleName: 'hl-wrap' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', {
              src: headlineImg,
              alt: 'Save for your future without ruining theirs',
              styleName: 'hl-img-sm visible-xs'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'hl' },
              'Save for your future without ruining theirs'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'copy' },
              manager.intro1,
              _react2.default.createElement(
                'p',
                { styleName: 'scroll-link' },
                _react2.default.createElement(
                  _reactScroll.Link,
                  {
                    activeClass: 'active-scroll-link',
                    to: 'section1',
                    spy: true,
                    smooth: true,
                    offset: -70,
                    duration: 500
                  },
                  _react2.default.createElement(
                    'b',
                    null,
                    'Tell ',
                    manager.companyshortname,
                    ' to adopt a No Deforestation Policy!'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'hidden-xs' },
                manager.intro2,
                _react2.default.createElement(
                  'div',
                  { styleName: 'petition-letter' },
                  _react2.default.createElement(
                    'blockquote',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        'To: ',
                        manager.companyshortname,
                        _react2.default.createElement('br', null),
                        'From: As You Sow & Friends of the Earth U.S.'
                      )
                    ),
                    manager.letter
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'after-petition-links hidden-xs' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links-lbl' },
                  'More'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links-div' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.families + '?q=' + manager.pathname,
                      title: manager.companyfullname,
                      xstrong: true
                    },
                    'See fund scores for ',
                    manager.companyfullname,
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links-div' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.clean,
                      title: 'Search funds',
                      xstrong: true
                    },
                    'Search all funds',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links-div' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.toolkit,
                      title: '#DefundDeforestation Action Toolkit',
                      xstrong: true
                    },
                    'Action toolkit',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'hl-img-wrap' },
            _react2.default.createElement('img', {
              src: headlineImg,
              alt: 'Save for your future without ruining theirs',
              styleName: 'hl-img hidden-xs'
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'petition-widget-wrap' },
              this.renderLogo(manager.imgpath),
              _react2.default.createElement(
                'div',
                { styleName: 'sticky-widget' },
                _react2.default.createElement('div', { id: 'section1' }),
                _react2.default.createElement('link', { href: 'https://actionnetwork.org/css/style-embed-v3.css', rel: 'stylesheet', type: 'text/css' }),
                _react2.default.createElement('script', { src: manager.widgeturl }),
                _react2.default.createElement('div', { id: manager.widgetid, style: { width: '100%' } }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'petition-widget-404-link' },
                  'If you opt in to email updates, you may receive emails from Friends of the Earth U.S. as well.',
                  _react2.default.createElement('br', null),
                  'Something went wrong loading the petition? ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: manager.url, title: manager.companyshortname + ' Needs a No Deforestation Policy', xstrong: true },
                    'Try signing here',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'visible-xs' },
          _react2.default.createElement(
            'div',
            {
              styleName: 'show-more-button',
              title: 'Show the full petition',
              onClick: function onClick(e) {
                _this2.setState({ showFullPetition: !_this2.state.showFullPetition });
              }
            },
            'Show the full petition',
            _react2.default.createElement(_components.LinkIcon, { faclass: this.state.showFullPetition ? 'fa-angle-double-up' : 'fa-angle-double-down' })
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state.showFullPetition ? _react2.default.createElement(
              'div',
              { styleName: 'copy' },
              manager.intro2,
              _react2.default.createElement(
                'div',
                { styleName: 'petition-letter' },
                _react2.default.createElement(
                  'blockquote',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'To: ',
                      manager.companyshortname,
                      _react2.default.createElement('br', null),
                      'From: As You Sow & Friends of the Earth U.S.'
                    )
                  ),
                  manager.letter
                )
              ),
              '                      '
            ) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'after-petition-links visible-xs' },
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links-lbl' },
            'More'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links-div' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.families + '?q=' + manager.pathname,
                title: manager.companyfullname,
                xstrong: true
              },
              'See fund scores for ',
              manager.companyfullname,
              _react2.default.createElement(_components.LinkIcon, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links-div' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.clean,
                title: 'Search funds',
                xstrong: true
              },
              'Search all funds',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links-div' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.routes.toolkit,
                title: '#DefundDeforestation Action Toolkit',
                xstrong: true
              },
              'Action toolkit',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        )
      );
    }
  }]);
  return ManagerPetition;
}(_react.Component)) || _class);
var Petitions = (_dec2 = (0, _reactCssModules2.default)(_Petitions2.default, { allowMultiple: true }), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(Petitions, _Component2);

  function Petitions(props) {
    (0, _classCallCheck3.default)(this, Petitions);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Petitions.__proto__ || (0, _getPrototypeOf2.default)(Petitions)).call(this, props));

    _this3.renderLogo = function (title) {
      var fileName = _format2.default.imgPath(title);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }
      if (hasLogo) {
        return _react2.default.createElement('img', {
          styleName: 'logo',
          src: companyLogo,
          alt: title
        });
      } else {
        console.log(fileName);
        return _react2.default.createElement(
          'span',
          null,
          title
        );
      }
    };

    var allowedAssetManagers = {
      vanguard: 'Vanguard',
      blackrock: 'BlackRock',
      fidelity: 'Fidelity',
      capitalgroup: 'Capital Group',
      dimensionalfundadvisors: 'Dimensional Fund Advisors',
      invesco: 'Invesco',
      jpmorgan: 'JPMorgan',
      mfs: 'MFS',
      statestreet: 'State Street',
      troweprice: 'T Rowe Price',
      tiaainvestmentsnuveen: 'TIAA Investments Nuveen'
    };

    _this3.state = {
      allowedAssetManagerParams: (0, _keys2.default)(allowedAssetManagers),
      allowedAssetManagers: allowedAssetManagers,
      familiesWithPetitions: (0, _keys2.default)(_config2.default.fundFamilyPetitions.data)
    };
    return _this3;
  }

  (0, _createClass3.default)(Petitions, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var title = 'Petitions';
      var headlineImg = require('../../../static/images/monkeys-circle.png');
      var foeImg = require('../../../static/images/FOE_logo.png');

      var name = null;

      // do we have a valid asset manager in params
      if (this.props.params && this.props.params.assetManager && this.state.allowedAssetManagerParams.includes(this.props.params.assetManager.toLowerCase().split(' ').join(''))) {
        name = this.state.allowedAssetManagers[this.props.params.assetManager.toLowerCase().split(' ').join('')];
      }

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          name ? null : _react2.default.createElement(
            'div',
            { styleName: 'hl-wrap' },
            _container2.default.helmet('Petitions', 'Ask major asset managers to adopt a No Deforestation policy.', _config2.default.domain + _config2.default.routes.petitions),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', {
                src: headlineImg,
                alt: 'Save for your future without ruining theirs',
                styleName: 'hl-img-sm visible-xs visible-sm'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'hl' },
                'Save for your future without ruining theirs'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                'Are you invested with one of the asset managers below? These mutual fund managers are among the world\u2019s top investors in the agribusiness companies responsible for destroying our tropical rainforests. Their continued financing of the world\u2019s worst deforesters exposes them and their clients to reputational and financial risk \u2013 and they have no policies in place to stop the destruction.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'hl-2' },
                'Choose an asset manager below to sign a petition asking them to adopt a No Deforestation policy.'
              )
            ),
            _react2.default.createElement('img', {
              src: headlineImg,
              alt: 'You can save for your future without ruining theirs',
              styleName: 'hl-img hidden-xs hidden-sm'
            })
          ),
          name ? _react2.default.createElement(ManagerPetition, { manager: name.toLowerCase().split(' ').join('') }) : _react2.default.createElement(
            'div',
            { styleName: 'logo-grid-wrap' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'logo-grid' },
              [{
                fund_family: 'Vanguard',
                imgpath: 'Vanguard'
              }, {
                fund_family: 'BlackRock',
                imgpath: 'BlackRock/iShares'
              }, {
                fund_family: 'Fidelity',
                imgpath: 'Fidelity Investments'
              }, {
                fund_family: 'Capital Group',
                imgpath: 'American Funds'
              }, {
                fund_family: 'Dimensional Fund Advisors',
                imgpath: 'Dimensional Fund Advisors'
              }, {
                fund_family: 'Invesco',
                imgpath: 'Invesco'
              }, {
                fund_family: 'JPMorgan',
                imgpath: 'JPMorgan'
              }, {
                fund_family: 'MFS',
                imgpath: 'MFS'
              }, {
                fund_family: 'State Street',
                imgpath: 'SPDR State Street Global Advisors'
              }, {
                fund_family: 'T Rowe Price',
                imgpath: 'T. Rowe Price'
              }, {
                fund_family: 'TIAA Investments Nuveen',
                imgpath: 'TIAA Investments/Nuveen'
              }].map(function (e, i) {
                return _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  {
                    styleName: 'logo-cell',
                    md: 3,
                    sm: 6,
                    xs: 12,
                    key: 'logo-cell-' + i
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-cell-inner' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.petitions + '/' + e.fund_family,
                        title: 'Sign the petition to ask ' + e.fund_family + ' for a No Deforestation Policy',
                        log: _analytics2.default.eventToFamilyTakeAction(e.fund_family),
                        targetBlank: true
                      },
                      _this4.renderLogo(e.imgpath)
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return Petitions;
}(_react.Component)) || _class3);
exports.default = Petitions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Petitions/Petitions.js
// module id = 1342
// module chunks = 0